































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Integration } from '@/views/settings/components/Integration.ts.vue';
import IntegrationForm from '@/views/settings/components/IntegrationForm.ts.vue'
import SalesForceIntegrationForm from '@/views/settings/components/SalesForceIntegrationForm.vue'
import APIIntegrationForm from '@/views/settings/components/APIIntegrationForm.vue'

@Component
export default class IntegrationTableBody extends Vue {
  @Prop() rows!: Integration[];
  @Prop() methods?: void;

  @Emit('selected')
  public clicktr(tr: Integration): Integration {
    return tr
  }

  @Emit('deleted')
  public deleteCompleted(tr: Integration): Integration {
    return tr
  }

  public onDeleteItem (item: Integration): void {
    this.$vs.dialog({
      type: 'confirm',
      color: 'danger',
      title: `Confirm Delete`,
      text: 'Are you sure you want to delete this integration?',
      acceptText: 'Yes, remove it',
      cancelText: 'No, keep it',
      accept: async () => {
        await this.$store.dispatch('visitManagement/removeIntegration', item.id);
        this.deleteCompleted(item);
      }
    })
  }

  public onUpdateItem (item: any) : void {
    this.$root.$tcPopup.show({
      data: item,
      classes: 'vs-dialog--md',
      title: 'Edit Integration',
      component: this.getComponent(item.integration.integrationType),
      acceptText: 'Save'
    });
  }

  private getComponent (integrationType: string): any {
    let form: any = null;
    switch(integrationType) {
      case "AzureAD":
        form = IntegrationForm;
        break;
      case "Salesforce":
        form = SalesForceIntegrationForm;
        break;
      case "API":
        form = APIIntegrationForm;
        break;
    }

    return form;
  }
}
